import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import {
  ScanVaultSoftwareService,
  SoftwareInventoryFilters,
  SoftwareInstallationPage,
  SoftwarePackagePage,
  SoftwareInventorySummary,
} from 'app/api/services/scanVaultSoftware';

import { actions } from './slice';

export function* doGetSoftwareInventory(
  ctx: QueryContext<SoftwareInventorySummary, SoftwareInventoryFilters>,
) {
  yield call(
    ctx.fetch,
    () =>
      ScanVaultSoftwareService.getSummary(
        ctx.params as SoftwareInventoryFilters,
      ),
    {
      map: value => value,
      errorMsg: 'Failed to load software inventory.',
    },
  );
}

export function* doGetSoftwareInstallations(
  ctx: QueryContext<SoftwareInstallationPage, SoftwareInventoryFilters>,
) {
  yield call(
    ctx.fetch,
    () =>
      ScanVaultSoftwareService.getInstallations(
        ctx.params as SoftwareInventoryFilters,
      ),
    {
      map: value => value,
      errorMsg: 'Failed to load software entities.',
    },
  );
}

export function* doGetSoftwarePackages(
  ctx: QueryContext<SoftwarePackagePage, SoftwareInventoryFilters>,
) {
  yield call(
    ctx.fetch,
    () =>
      ScanVaultSoftwareService.getPackages(
        ctx.params as SoftwareInventoryFilters,
      ),
    {
      map: value => value,
      errorMsg: 'Failed to load software packages.',
    },
  );
}

export function* softwareInventorySaga() {
  yield takeLatestAction(actions.getSoftwareInventory, doGetSoftwareInventory);
  yield takeLatestAction(actions.getSoftwarePackages, doGetSoftwarePackages);
  yield takeLatestAction(
    actions.getSoftwareInstallations,
    doGetSoftwareInstallations,
  );
}
